module.exports = __webpack_public_path__ + "assets/video-player.fe382954.svg";